import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom'
import PageIntro from './PageIntro';
import PageUploader from './PageUploader';
import { withRouter } from 'react-router-dom';
import { DataCenter, DataContext } from './utility/DataContext';


class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.data = new DataCenter();
  }

  render() {
    return (
      <DataContext.Provider value={this.data}>
        <Switch>
          <Route exact path="/" component={PageIntro}/>
          <DataContext.Consumer>
            {data => <Route path="/upload" render={props => <PageUploader {...props} data={data} />} />}
          </DataContext.Consumer>
        </Switch>
      </DataContext.Provider>
    );
  }
}

export default withRouter(Page);


// WEBPACK FOOTER //
// ./src/Page.js